<template>
  <div id="app">
    <router-view class="container" />
  </div>
</template>

<script>
export default {
  name: "App",
  data() {
    return {
      deviceNum: ""
    };
  },
  created() {
    //获取设备编号
    this.deviceNum = this.getUrlKey("deviceNum");
    if (this.deviceNum) {
      localStorage.deviceNum = this.deviceNum;
    }
  },
  mounted() {
    var api_token = localStorage.api_token;
    if (api_token == undefined || api_token == "" || api_token == null) {
      this.$api.login(this.deviceNum).then(res => {
        if (res.status == 1) {
          localStorage.api_token = res.data.api_token;
        }
      });
    }
  },
  methods: {
    getUrlKey(key) {
      return (
        decodeURIComponent(
          (new RegExp("[?|&]" + key + "=" + "([^&;]+?)(&|#|;|$)").exec(
            location.href
          ) || [, ""])[1].replace(/\+/g, "%20")
        ) || null
      );
    }
  }
};
</script>

<style lang="css">
html {
  margin: 0;
  padding: 0;
}
* {
  margin: 0;
  padding: 0;
  box-sizing: border-box;
  user-select: none;
}
.back {
  width: 213px;
  height: 98px;
  line-height: 98px;
  box-shadow: 0px 4px 13px 0px rgba(185, 32, 80, 0.35);
  border-radius: 49px 0px 0px 49px;
  background: #fff;
  color: #b95020;
  font-size: 30px;
  text-align: center;
  position: fixed;
  bottom: 10%;
  right: 0;
  z-index: 998;
  font-weight: 500;
}
html,
body {
  width: 1080px;
  min-height: 1920px;
  margin: 0 auto;
  font-size: 14px;
  font-family: PingFangSC-Regular, Microsoft YaHei, Helvetica, STHeiTi,
    "sans-serif";
  -webkit-overflow-scrolling: touch;
  -webkit-font-smoothing: antialiased;
}
</style>



// WEBPACK FOOTER //
// src/App.vue